export const mobilePreview = () => {
  return {
    review_and_authorize: 'Review and Authorize',
    percentage_complete: '{{ percentage }} % complete',
    all_set: 'All Set!',
    service_form: 'Service Form',
    helpful_hint: 'Helpful Hint',
    ok: 'Ok',
    cancel: 'Cancel',
    select: 'Select',
    add: 'Add',
    collapsed_message: 'Section is collapsed. Tap to expand.',
    tasks_remaining: '{{ number }} Tasks Remaining',
    signature: {
      sign_here: 'Sign here',
      enter_name_here: 'Enter name here'
    },
    check_list: {
      on: 'On',
      yes: 'Yes',
      off: 'Off',
      no: 'No'
    },
    photos: {
      photos_required: '{{ number }} Photos Required',
      photo_required: '1 Photo Required'
    },
    attachments: {
      attachments_required: '{{ number }} Required',
      attachment_required: '1 Required'
    },
    text_description: {
      enter_description: 'Enter description',
      enter_value: 'Enter value...'
    },
    material: {
      price: 'Price',
      total_price: 'Total Price',
      item_price: 'Item Price',
      per_item_price: 'Per Item Price',
      material: 'Material',
      enter_name: 'Enter Item Name',
      item_number_name: 'Item {{number}} name',
      enter_description: 'Enter Description Here..',
      item_description: ' Item Description',
      item: 'Item',
      name: 'Name',
      description: 'Description',
      qty: 'QTY',
      quantity: 'Quantity',
      unit_price: 'Unit Price',
      total: 'Total',
      tax: 'Tax'
    },
    line_item: {
      labor_type: 'Labor Type',
      total_price: 'Total Price',
      total_amount: 'Total Amount',
      labor: 'Labor',
      line_item: 'Line Item',
      additinal_description: 'Additional Description',
      enter: 'Enter',
      amount: 'Amount',
      rate: 'Rate',
      enter_name: 'Enter Item Name',
      item_number_name: 'Item {{number}} name',
      enter_description: 'Enter Description Here..',
      item_description: ' Item Description',
      item: 'Item',
      name: 'Name',
      description: 'Description',
      qty: 'QTY',
      quantity: 'Quantity',
      unit_price: 'Unit Price',
      total: 'Total',
      tax: 'Tax'
    },
    authorization_field: {
      authorization: 'Authorization',
      total_amount_due: 'Total Amount Due',
      sign: 'Sign',
      due_on_receipt: 'Due on receipt',
      signature: 'Signature',
      name: 'Name',
      payment_terms: 'Payment Terms',
      payment_due: 'Payment Due',
      authorization_to_proceed: 'Authorization To Proceed',
      review_and_authorize: 'Review & Authorize',
      generate_review: 'Generate Review',
      review_and_authorization: 'Review & Authorization',
      work_authorized: 'Work Authorized',
      not_authorized: 'Not Authorized'
    }
  }
}
